// 公共组件翻译汇总
import button from "./button.js";
import input from "./input.js";
import customerService from "./customer-service.js";
import chart from "./chart.js";

export default {
  button,
  input,
  customerService,
  chart,
  // 通用消息
  languageSwitched: "语言已切换为",
  loading: "拼命加载中",
  success: "成功",
  error: "错误",
  warning: "警告",
  confirm: "确认",
  cancel: "取消",
  empty: "暂无数据",
  // 网络请求错误
  networkError: "网络异常，请检查网络，或者稍后重试",
  requestTimeout: "请求超时，请检查网络或稍后重试",
  // 专业版功能提示弹窗（$tbProFeature）
  proFeature: {
    title: "系统提示",
    description: "当前功能仅专业版用户可用，请扫码咨询客服",
    qrAlt: "客服二维码",
    confirm: "知道了",
  },
};
